import React, { FunctionComponent } from "react";
import { FormSection } from "../../../FormSection";
import { Grid, MenuItem } from "@mui/material";
import { SectionProps } from "../props";
import { CustomSelect } from "../../../CustomSelect";
import { CustomInput } from "../../../CustomInput";

type AdditionalFieldsState = {
  formFields: any[];
  onChangeFormFieldSelect: (event: any, index: number) => void;
  onChangeFormField: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => void;
};

export const AdditionalFields: FunctionComponent<
  AdditionalFieldsState & SectionProps
> = (props) => {
  return (
    <FormSection title="Additional Fields" isCollapsible>
      {props.formFields.map((item, index) => {
        if (item.fieldType === "D") {
          return (
            <Grid item>
              <CustomSelect
                name={item.fieldName}
                value={item.selectedValue}
                onChange={(event) =>
                  props.onChangeFormFieldSelect(event, index)
                }
                label={`${item.fieldName} ${item.required ? "*" : ""}`}
              >
                {item.dropdownValues.map((item: any, index: number) => {
                  return (
                    <MenuItem key={index} value={item.id}>
                      {item.description}
                    </MenuItem>
                  );
                })}
              </CustomSelect>
            </Grid>
          );
        } else {
          return (
            <Grid item>
              <CustomInput
                label={{
                  text: `${item.fieldName} ${item.required ? "*" : ""}`,
                }}
                name={item.fieldName}
                value={item.selectedValue}
                onChange={(event) => props.onChangeFormField(event, index)}
                height={35}
              />
            </Grid>
          );
        }
      })}
    </FormSection>
  );
};
